'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { getCart as getCartInStorage } from '@services/cart';
import { fetchSinglePlan } from '@services/products';

import { MobilePlanType } from '@app-types/plan';

export function useFetchSinglePlan(planId?: string) {
    const [isLoading, setIsLoading] = useState(true);
    const [mobilePlanDetailed, setMobilePlanDetailed] = useState<MobilePlanType | null>(null);
    const params = useSearchParams();

    useEffect(() => {
        const loadPlanDetails = async () => {
            setIsLoading(true);
            try {
                let planToFetch: string = '';
                if (planId) {
                    planToFetch = planId;
                } else {
                    const checkoutCart = getCartInStorage();
                    if (checkoutCart && params?.has('from-widget')) {
                        const planFromCart = checkoutCart.products.find(
                            (product) => product.productLine === 'Forfaits_mobile',
                        );
                        if (planFromCart) {
                            planToFetch = planFromCart.gencode;
                        }
                    }
                }

                if (planToFetch) {
                    const plan = await fetchSinglePlan(planToFetch);
                    if (plan) {
                        setMobilePlanDetailed(plan);
                    }
                }
            } catch (error) {
                console.error('Failed to load plan details:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadPlanDetails();
    }, [planId, params]);

    return {
        isLoading,
        mobilePlanDetailed,
    };
}
